module.exports = __webpack_public_path__ + "media/images/top-content-img-1-e223a9a3d2bd59052c9612ca42b907b8.jpg";